import { createContext, useContext, useReducer } from 'react';

const DepositContext = createContext(null);

export const useDepositContext = () => {
  const ctx = useContext(DepositContext);
  if (!ctx) throw new Error('useDepositContext doit être utilisé dans <DepositProvider>');
  return ctx;
};

const initialState = {
  fetchAlert: false,
  alertMessage: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'PAGE_DEPOSIT_STATES_UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function DepositProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { ...state, dispatch };
  return <DepositContext.Provider value={value}>{children}</DepositContext.Provider>;
}
